export function sortByObject(field) {
  return function(obj1, obj2) {
    if (obj1[field] > obj2[field]) return 1;
    if (obj1[field] < obj2[field]) return -1;
    return 0;
  };
}
